/**
 * Country Configuration
 * 
 * Central configuration for all supported countries in the multi-country architecture.
 * Each country has its own subdomain (e.g., peru.lotespro.com, mexico.lotespro.com)
 */

export const COUNTRY_CONFIG = {
    peru: {
        code: 'PE',
        name: 'Perú',
        currency: 'PEN',
        currencySymbol: 'S/',
        defaultCenter: [-9.19, -75.0152], // Center of Peru
        defaultZoom: 5,
        flag: '🇵🇪',
        locale: 'es-PE',
        region: 'Sudamérica'
    },
    mexico: {
        code: 'MX',
        name: 'México',
        currency: 'MXN',
        currencySymbol: '$',
        defaultCenter: [23.6345, -102.5528], // Center of Mexico
        defaultZoom: 5,
        flag: '🇲🇽',
        locale: 'es-MX',
        region: 'Norteamérica'
    },
    chile: {
        code: 'CL',
        name: 'Chile',
        currency: 'CLP',
        currencySymbol: '$',
        defaultCenter: [-35.6751, -71.543], // Center of Chile
        defaultZoom: 5,
        flag: '🇨🇱',
        locale: 'es-CL',
        region: 'Sudamérica'
    },
    colombia: {
        code: 'CO',
        name: 'Colombia',
        currency: 'COP',
        currencySymbol: '$',
        defaultCenter: [4.5709, -74.2973], // Center of Colombia
        defaultZoom: 5,
        flag: '🇨🇴',
        locale: 'es-CO',
        region: 'Sudamérica'
    },
    argentina: {
        code: 'AR',
        name: 'Argentina',
        currency: 'ARS',
        currencySymbol: '$',
        defaultCenter: [-38.4161, -63.6167], // Center of Argentina
        defaultZoom: 4,
        flag: '🇦🇷',
        locale: 'es-AR',
        region: 'Sudamérica'
    },
    ecuador: {
        code: 'EC',
        name: 'Ecuador',
        currency: 'USD',
        currencySymbol: '$',
        defaultCenter: [-1.8312, -78.1834], // Center of Ecuador
        defaultZoom: 6,
        flag: '🇪🇨',
        locale: 'es-EC',
        region: 'Sudamérica'
    },
    bolivia: {
        code: 'BO',
        name: 'Bolivia',
        currency: 'BOB',
        currencySymbol: 'Bs.',
        defaultCenter: [-16.2902, -63.5887], // Center of Bolivia
        defaultZoom: 5,
        flag: '🇧🇴',
        locale: 'es-BO',
        region: 'Sudamérica'
    },
    paraguay: {
        code: 'PY',
        name: 'Paraguay',
        currency: 'PYG',
        currencySymbol: '₲',
        defaultCenter: [-23.4425, -58.4438], // Center of Paraguay
        defaultZoom: 6,
        flag: '🇵🇾',
        locale: 'es-PY',
        region: 'Sudamérica'
    },
    uruguay: {
        code: 'UY',
        name: 'Uruguay',
        currency: 'UYU',
        currencySymbol: '$',
        defaultCenter: [-32.5228, -55.7658], // Center of Uruguay
        defaultZoom: 6,
        flag: '🇺🇾',
        locale: 'es-UY',
        region: 'Sudamérica'
    },
    "republica-dominicana": {
        code: 'DO',
        name: 'República Dominicana',
        currency: 'DOP',
        currencySymbol: '$',
        defaultCenter: [18.7357, -70.1627], // Center of Dominican Republic
        defaultZoom: 7,
        flag: '🇩🇴',
        locale: 'es-DO',
        region: 'Caribe'
    },
    panama: {
        code: 'PA',
        name: 'Panamá',
        currency: 'PAB',
        currencySymbol: 'B/.',
        defaultCenter: [8.5380, -80.7821], // Center of Panama
        defaultZoom: 7,
        flag: '🇵🇦',
        locale: 'es-PA',
        region: 'Centroamérica'
    },
    "costa-rica": {
        code: 'CR',
        name: 'Costa Rica',
        currency: 'CRC',
        currencySymbol: '₡',
        defaultCenter: [9.7489, -83.7534], // Center of Costa Rica
        defaultZoom: 7,
        flag: '🇨🇷',
        locale: 'es-CR',
        region: 'Centroamérica'
    },
    guatemala: {
        code: 'GT',
        name: 'Guatemala',
        currency: 'GTQ',
        currencySymbol: 'Q',
        defaultCenter: [15.7835, -90.2308], // Center of Guatemala
        defaultZoom: 6,
        flag: '🇬🇹',
        locale: 'es-GT',
        region: 'Centroamérica'
    },
    honduras: {
        code: 'HN',
        name: 'Honduras',
        currency: 'HNL',
        currencySymbol: 'L',
        defaultCenter: [15.2000, -86.2419], // Center of Honduras
        defaultZoom: 6,
        flag: '🇭🇳',
        locale: 'es-HN',
        region: 'Centroamérica'
    },
    "el-salvador": {
        code: 'SV',
        name: 'El Salvador',
        currency: 'USD',
        currencySymbol: '$',
        defaultCenter: [13.7942, -88.8965], // Center of El Salvador
        defaultZoom: 7,
        flag: '🇸🇻',
        locale: 'es-SV',
        region: 'Centroamérica'
    },
    nicaragua: {
        code: 'NI',
        name: 'Nicaragua',
        currency: 'NIO',
        currencySymbol: 'C$',
        defaultCenter: [12.2650, -85.2072], // Center of Nicaragua
        defaultZoom: 6,
        flag: '🇳🇮',
        locale: 'es-NI',
        region: 'Centroamérica'
    },
    venezuela: {
        code: 'VE',
        name: 'Venezuela',
        currency: 'VES',
        currencySymbol: 'Bs.',
        defaultCenter: [6.4238, -66.5897], // Center of Venezuela
        defaultZoom: 5,
        flag: '🇻🇪',
        locale: 'es-VE',
        region: 'Sudamérica'
    }
};

/**
 * List of all supported country subdomains
 */
export const SUPPORTED_COUNTRIES = Object.keys(COUNTRY_CONFIG);

/**
 * Default country to use when none is specified
 */
export const DEFAULT_COUNTRY = 'peru';

/**
 * Global domain configuration (for country selector)
 */
export const GLOBAL_DOMAINS = ['lotespro.com', 'www.lotespro.com', 'localhost'];
